<style>
    /* Set the page size to A4 and the orientation to landscape */
    @page {
        size: letter portrait;
        margin: 3%;
    }

    /* Set the font size to 12px for printing */
    @media print {
        body {
            /* font-size: 14px; */
            font-family: 'Courier New', Courier, monospace;
            height: 99%;
            /* zoom: 84%; */
        }
        .break-before{
            page-break-before:always;
        }
        .print-foot {
            display:block !important;
        }
        .page-number:before {
            content: "Page: " counter(page);
        }
        
        .contentPrint{
            display: block !important;
            margin:0px !important;
            max-width: 100% !important;
        }
        .print-page {
            break-after: page;
            page-break-after: always;
        }

        .print-page:last-child {
            break-after: auto;
            page-break-after: auto;
        }
        /* .print-foot-2 {
            bottom: 405px !important;
        } */
    }
    *{
        /* font-size: 14px; */
        font-family: 'Courier New', Courier, monospace;
        line-height: normal !important;
    }

    #logo {
        position: absolute;
        top: 2px;
        right: 2px;
        width: 200px;
        height: 100px;
    }

    .title ,.title th{
        font-size: small;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .head p,.head th{
        font-size: small;
        font-weight: bold;
        color: black;
    }
    .body p,.body td{
        font-size: small;
    }

    table {
        font-family: arial, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #no-border {
        border: none;
    }

    td, th {
        border: 2px solid #000000;
        text-align: left;
        padding: 8px;
        line-height: 2;
    }

    .lh-1,.lh-1 th{
        line-height: 1;
    }
    .lh-1\/2,.lh-1\/2 p{
        line-height: 1.5;
    }

    .remove_border tr th{
        border: none;
    }
    .bb-dashed{
        border-bottom: dashed;
        border-bottom-width: medium;
        margin-top: 3px;

    }
    .bt-dashed{
        border-top: dashed !important;
        border-top-width: medium;
        margin-bottom: 3px;
    }
    .no-border th,.no-border td{
        border: none;
        padding: 2px;
    }

    #table-list {
        margin-top: 80px;
    }

    #info {
        margin-top: 20px;
        width: 40%;
        float: left;
        margin-bottom: 20px;
    }

    .space-for-logo {
        width: 200px;
        height: 100px;
    }

    .text-uppercase {
        text-transform: uppercase !important;
    }
    .text-capitalize {
        text-transform: capitalize !important;
    }
    .print-foot {
        position: relative;
        left: 0;
        right: 0px;
        display: block;
    }
    .print-foot-hide {
        display:block
    }
    .contentPrint{
        margin:50px;
        max-width: 600px;
        display: none;
    }
</style>

<template>
    <div id="contentPrint">
        <div class="contentPrint print-page" v-for="(so, index) in salesOrders" :key="index">
            <table class="vx-row my-3">
                <tbody>
                    <tr class="no-border head">
                        <th class="align-top pl-6">
                            <p class="text-uppercase" style="margin: 0!important;">{{so.BillAddress.Zone.CompanyName }}</p>
                            <p class="text-capitalize" style="margin: 0!important;">Cab. {{capitalize(so.TerritoryName ? so.TerritoryName : so.Territory.Name ) }}</p>
                            <p>{{so.Territory.TerritoryGeo.Address }}</p>
                            <br />
                            <p>{{so.Customer.CustomerPhone }}</p>
                            <br />
                            <p>NPWP: {{so.Customer.Company.Npwp }}</p>
                            <br />
                            <p>Sold-To-Party</p>
                            <p>{{so.BillAddress.ContactName }}</p>
                            <p>{{so.Customer.AltName }}</p>
                            <p>{{so.BillAddress.Address }}</p>
                            <p>{{so.BillAddress.SubDistrict }}</p>
                            <p>{{so.BillAddress.PostalCode }}</p>
                            <br />
                            <p>NPWP: {{so.Customer.Npwp }}</p>
                            <br />
                        </th>
                        <th class="align-top" style="min-width: 255px">
                            <p class="text-uppercase title bb-dashed text-center" style="font-size: medium;">Sales Order</p>
                            <!-- <div class="vx-row mt-3 body"> -->
                            <table>
                                <tbody>
                                    <tr class="no-border">
                                        <td class="align-top">Order Type</td>
                                        <td class="align-top"></td>
                                        <td class="align-top">{{ so.Category }}</td>
                                    </tr>
                                    <tr class="no-border">
                                        <td class="align-top">Number/Date</td>
                                        <td class="align-top"></td>
                                        <td class="align-top">{{ so.PoReferenceCode + "/ "+formatDate(so.Date)}}</td>
                                    </tr>
                                    <tr class="no-border">
                                        <td class="align-top">Reference No.</td>
                                        <td class="align-top"></td>
                                        <td class="align-top">{{ so.Code }}</td>
                                    </tr>
                                    <tr class="no-border">
                                        <td class="align-top">Ref. Date/ RDD</td>
                                        <td class="align-top"></td>
                                        <td class="align-top">{{ formatDate(so.PoReferenceDate) +"/ "+formatDate(so.RequestDeliveryDate) }}</td>
                                    </tr>
                                    <tr class="no-border">
                                        <td class="align-top">Customer No. </td>
                                        <td class="align-top"></td>
                                        <td class="align-top">{{ so.Customer.Code }}</td>
                                    </tr>
                                    <tr class="no-border">
                                        <td class="align-top">Sales. No./ Name</td>
                                        <td class="align-top"></td>
                                        <td class="align-top">{{ so.SalesPersonalCodeExternal+"/ "+so.SalesPersonalName }}</td>
                                    </tr>
                                    <tr class="no-border">
                                        <td class="align-top">Term of Payment</td>
                                        <td class="align-top"></td>
                                        <td class="align-top">{{ "Due within "+so.PaymentTerm.DueInvoicePeriod+" days" }}</td>
                                    </tr>
                                    <tr class="no-border">
                                        <td class="align-top">Condition Delivery</td>
                                        <td class="align-top"></td>
                                        <td class="align-top">{{ so.DeliveryTypeName }}</td>
                                    </tr>
                                    <tr class="no-border">
                                        <td class="align-top">Tax Status / Currency</td>
                                        <td class="align-top"></td>
                                        <td class="align-top">{{ so.Customer.IsPkp=="0"?"Non PKP":"PKP" }}/IDR</td>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- </div> -->
                        </th>
                    </tr>
                </tbody>
            </table>
            <PrintTable :salesOrder="so" :page="1"></PrintTable>
            <!-- salesOrder.foot_top -->
            <div v-if=" 1 != so.total_page" class="vx-row m-3 print-foot print-foot-hide" :style="{'top':'20px !important'}">
                <table>
                    <tfoot>
                        <tr class="no-border head">
                            <th colspan="2"></th>
                            <th class="text-right">Page {{ (so.ListPage.find(item => item.child_page === 1) || {}).parent_page + " of " + total_page }}</th>
                            <!-- + salesOrders.length -->
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div v-for="(n) in so.total_page" :key="n">
                <div v-if="n > 1">
                    <PrintTable class="break-before" :salesOrder="so" :page="n"></PrintTable>
                    <div v-if="n < so.total_page&& n != so.total_page" class="vx-row m-3 print-foot print-foot-hide" :style="{'top':so.foot_top+'px !important'}">
                        <table>
                            <tfoot>
                                <tr class="no-border head">
                                    <th colspan="2"></th>
                                    <th class="text-right">Page {{ (so.ListPage.find(item => item.child_page === n) || {}).parent_page + " of "+ total_page }}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>


            <div class="bb-dashed head lh-1/2">
                <p>SAY : {{ terbilang(so.Total) }}</p>
            </div>
            <div class="bb-dashed head lh-1/2">
                <p>Customer PO. No. : {{ so.Code }}</p>
                <p>Message : {{ so.Notes }}</p>
            </div>
            <div class="head lh-1/2">
                <p>Shipping Address :
                {{so.ShipAddress.ContactName }} -
                {{so.ShipAddress.Address }} -
                {{so.ShipAddress.SubDistrict }} -
                {{so.ShipAddress.City }} -
                {{so.ShipAddress.PostalCode }}</p>
            </div>
            <div class="vx-row m-3 print-foot print-foot-hide" :style="{'top':'20px !important'}">
                <table>
                    <tbody>
                        <tr class="no-border head">
                            <th class="align-bottom">Bank Account :</th>
                            <th></th>
                            <th class="text-center p-0">
                                SE & O <br /><br /><br />
                                (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                            </th>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr class="no-border head">
                            <th colspan="2"></th>
                            <th class="text-right mt-6 pt-6">Page {{ (so.ListPage.find(item => item.child_page === so.total_page) || {}).parent_page + " of " + total_page }}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
            <!-- {{ print() }} -->
    </div>
</template>

<script>
import moment from "moment";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import PrintTable from "./print-table.vue"
// import moment from "moment-timezone";
// import logoSDN from "../../../assets/images/logo/logo-sdn.png";

export default {
    name: "PrintPdf",
    components: {
        PrintTable
    },
    data() {
        return {
            id: null,
            co_code: null,
            so_id: null,
            so_ids: null,
            reqCode: null,
            unlCode: null,
            selectedWarehouse: null,
            selectedSales: null,
            loadingDate: null,
            unloadingDate: null,
            salesOrder:{
                page:1,
                total_page:1,
                print_foot_top :200,
                foot_top:0,
            },
            salesOrders:[{
                page:1,
                total_page:1,
                print_foot_top :200,
                foot_top:0,
            }],
            total_page:1,
            // logoSDN: logoSDN,
            showInfo: false,
            say:"",
            max_per_item :35,
        }
    },
    watch:{
        salesOrder :function(v){
            if (this.salesOrder) {
                console.log(this.salesOrder)
                // this.$nextTick(() => {
                //     window.print();
                // });
                // this.print()
            }
        }
    },
    async mounted() {
        this.id = this.$route.params.id;
        if (this.id) {
            console.log(this.id)
            await this.getDataManage();
            Promise.all([
                this.getIdSo(),
            ]).then((r) => {
                console.log(r);
                // if(this.so_id != null && this.so_id != 0){
                // }
                this.$vs.loading();
                this.salesOrders = []
                // Promise.all([this.getDatav2(this.so_ids[0])]).then((r) => {
                this.total_page = 1;
                Promise.all(this.so_ids.map((id) => this.getDatav2(id))).then((r) => {
                    this.setDataPrint()
                    this.$nextTick(() => {
                        setTimeout(()=>{
                            this.print();
                        },2000)
                    });
                    console.log("promoise resolve=>",r);
                }).finally(() => {
                    console.log("this.salesOrders=>",this.salesOrders)
                    this.$vs.loading.close();
                });
                console.log("this.so_ids", this.so_ids)
                // this.$vs.loading.close();
                this.$vs.notify({
                    color: "success",
                    title: "Get Data",
                    text: r[0].message,
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-check-circle",
                  });
            }).catch(function (error) {
                this.$vs.notify({
                    color: "danger",
                    title: "Get Data",
                    text: "Error on get data",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-x-circle",
                });
                console.log(error);
            });
        }
    },
    methods: {
        tableDefaultState() {
            return {
                data: [],
            };
        },
        print(){
            // let contentOri = document.querySelector('body').innerHTML
            let contentPrint = document.getElementById("contentPrint").innerHTML
            document.body.innerHTML = contentPrint
            window.print()
            // document.body.innerHTML = contentOri
        },
        async getDataManage() {
            let url = "/api/sfa/v1/customer-order/find-by-corequest-id2/" + this.id;
            this.$vs.loading();
            let resp = await this.$http.get(url);

            console.log(resp);
            if (resp.code == 200 && resp.data.records[0].customer_order_id != 0) {
                console.log(resp.data);
                this.co_code = resp.data.records[0].customer_order_code
                console.log("this.co_code", this.co_code)
            } else {
                console.log(resp.data);
            }
            console.log(resp.data);

            this.$vs.loading.close();
        },
        async getIdSo() {
            console.log("getIDSo")
            var refpoCode = this.co_code ? this.co_code.replace(/\|/g, ",") : "";
            return new Promise((resolve, reject) => {
                let paramTable = {
                    search: "ref_po_code@in:" + refpoCode,
                    limit: 10,
                    offset: 0,
                    so_types: ["ZDCV"],
                    territory_code: "All",
                    is_use_approval_matrix: false,
                    progress_restriction: true,
                    progress_status: "allocated",
                    canvas_tab_type: "billing",
                    is_billed: 1,
                    // start_date: 2024-12-16T03:30:10.493Z,
                    // end_date: 2024-12-16T03:30:10.493Z,
                }
                this.$http.get("/api/oms/v1/sfa-sales-order/sales-order-mix2", {params:paramTable,}) .then((resp) => {
                    console.log(resp);
                    if (resp.code == 200) {
                        console.log(resp.data);
                        this.so_ids = []
                        resp.data.SalesOrders.forEach((el, i) => {
                            if (el.DefaultAttribute && el.DefaultAttribute.ID) {
                                this.so_ids.push(el.DefaultAttribute.ID)
                            } else {
                                this.so_ids.push(el.ID)
                            }
                        })
                        this.co_code = resp.data.SalesOrders[0].Code
                        console.log("this.co_code", this.co_code)

                        // if(resp.data.SalesOrders.length > 0) {
                        //     this.so_id = resp.data.SalesOrders[0].DefaultAttribute.ID ? resp.data.SalesOrders[0].DefaultAttribute.ID : resp.data.SalesOrders[0].ID
                        // }
                        console.log("this.so_ids", this.so_ids)
                        resolve(true);
                    } else {
                        console.log(resp.data);
                        reject(false);
                    }
                    console.log(resp.data);
                });

            });
        },
        setDataPrint(){
            var newSO=[]
            this.salesOrders.forEach((el, i) => {
                this.total_page = this.total_page + i
                let totalItem =0
                const loopSplit = 10
                const loopSplit2 = 25
                let tempLoopSplit = loopSplit
                let totalDpp = 0
                var tempSO = el
                tempSO.ListPage = [{
                    child_page: tempSO.total_page,
                    parent_page:this.total_page,
                }]
                tempSO.Items.forEach((el2,i2)=>{
                    if (el2.lines) {
                        // for (let i = 0; i < 100; i++) { //for testing
                        //     el2.lines.push({
                        //         ...el2.lines[0]
                        //     })
                        // }
                        el2.lines.forEach((el3,i3)=>{
                            totalDpp +=
                            (parseFloat(el3.subtotal))-
                            parseFloat(el3.discount)+
                            parseFloat(el3.rounding)+
                            parseFloat(el3.gross_up)
                            tempSO.Items[i2].lines[i3].page = tempSO.total_page
                            if (totalItem==tempLoopSplit) {
                                tempSO.Items[i2].lines[i3].break =".break-after"
                                tempSO.total_page++
                                this.total_page++
                                tempSO.ListPage.push({
                                    child_page: tempSO.total_page,
                                    parent_page:this.total_page,
                                })
                                tempLoopSplit +=loopSplit2
                            }
                            totalItem++
                        })
                    }
                })
                tempSO.total_dpp = totalDpp
                if (totalItem == 0) {
                    totalItem = 1
                }
                if (totalItem > 10) {
                    tempSO.print_foot_top = 20
                }else{
                    tempSO.print_foot_top = 200
                }
                tempSO.foot_top = tempSO.print_foot_top 
                tempSO.total_pageV2 = this.total_page
                newSO.push(tempSO)
                console.log("tempSO=>",tempSO)
            })
            this.salesOrders = newSO
        },
        async getDatav2(soID = 0) {
            let paramTables = {
                sales_order_id: soID,
                print:true,
            }
            return new Promise((resolve, reject) => {
                this.$http.get("/api/oms/v1/sfa-sales-order/sales-order-mix2", {params: paramTables}).then(resp => {
                      console.log("resp", resp)
                      if (resp.code == 200) {
                          if (resp.data.SalesOrders) {
                            resp.data.SalesOrders.forEach((el, i) => {
                                if (el) {
                                    el.page=1
                                    el.total_page=1
                                    el.foot_bottom=0
                                    this.salesOrders.push(el)
                                }
                                resolve(true);
                            })
                          }
                          
                      } else {
                          reject(false);
                      }
                    //   this.print()
                  }).catch((error) => {
                    console.log(error);
                    reject(false);
                  })
            })
        },
        formatCurrency(nominal) {
            if(nominal && nominal > 0) { // nominal > 0 untuk handle return NaN
                nominal = (nominal/1);
                return nominal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            } else {
                return 0;
            }
        },
        terbilang(angka) {
            return angkaTerbilang(angka).toUpperCase() + " RUPIAH"
        },
        capitalize(text){
            // text = "Pati UNUS"
            console.log("text", text)
            let word = text.toLowerCase().split(" ");
            console.log("word", word)
            for (var i = 0; i < word.length; i++) {
                word[i] = word[i].charAt(0).toUpperCase() + word[i].slice(1);
            }
            const new_text = word.join(" ");
            return new_text
        }
    },
    computed: {
        formatDate: () => {
            return (val) => {
                const momentDate = moment.utc(val);
                return momentDate.format('DD.MM.YYYY');
            };
        },
    },
}
</script>